// This file contains constants used throughout the application.
const CONSTANTS_DETAILS_CONFIG = {
  APP_NAME: 'Texicon',
  APP_DEAULT_LANGUAGE: 'en',
  GET_TRANSLATION: 'Metadata/get-translation-tokens',

  APP_MENUS: [
    {
      label: 'view_texicon',
      link: 'dashboard/view-texicon',
      icon: 'grid_view',
      isDivider: false,
    },
    {
      label: 'manage_ref',
      link: 'dashboard/manage-references',
      icon: 'bookmark',
      isDivider: false,
    },
    {
      label: 'settings',
      link: null,
      icon: 'settings',
      isDivider: true,
      children: [
        {
          label: 'Manage Lookup',
          link: '/settings/manage-lookup',
          icon: 'find_replace',
        },
        {
          label: 'Manage Approvers',
          link: '/settings/manage-approvers',
          icon: 'supervisor_account',
        },
        {
          label: 'roles_permissions',
          link: '/settings/role-matrix',
          icon: 'security',
        },
      ],
    },
  ],
  LOOKUP_TYPES: [
    {
      label: 'Tasting Stage',
      value: 'TastingStage',
      BASE_URL: 'TastingStage/tastingstage-master',
      BASE_URL_ENABLE_DISABLE: 'TastingStage/update-tastingstage-status',
    },
    {
      label: 'Country',
      value: 'Country',
      BASE_URL: 'Country/country-master',
      BASE_URL_ENABLE_DISABLE: 'Country/update-country-status',
    },
    {
      label: 'Region',
      value: 'Region',
      BASE_URL: 'Region/region-master',
      BASE_URL_ENABLE_DISABLE: 'Region/update-region-status',
    },
    {
      label: 'Medium',
      value: 'Medium',
      BASE_URL: 'Medium/medium-master',
      BASE_URL_ENABLE_DISABLE: 'Medium/update-medium-status',
    },
  ],
  PAGE_SIZE_OPTIONS: [9, 18, 27],
  DEFAULT_PAGE_SIZE: 9,
  DATE_TIME_FORMAT: 'MM/dd/yyyy hh:mm a',
  DATE_FORMAT: 'MM/dd/yyyy',
  ALLOWED_FILE_TYPES: [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/svg+xml',
    'image/webp',
  ],
  MAX_FILE_SIZE_BYTES: 10 * 1024 * 1024, // 10 MB
  EXCLUDED_ATTRIBUTE_STATUSES: ['pending', 'rejected', 'underreview'],
  ATTRIBUTE_PAGE_SIZE: 100,
  //Base URLs for service functions
  TASTING_STAGE_API_ENDPOINT: 'TastingStage/tastingstage-master',
  MEDIUM_API_ENDPOINT: 'Medium/medium-master',
  ATTRIBUTE_MASTER: 'Attribute/attribute-master',
  ATTRIBUTE_MASTER_W_MEDIUM: 'Attribute/attribute-medium-master',
  ATTRIBUTE_DETAIL: 'Attribute/get-attribute-details',
  ATTRIBUTE_POST_API_ENDPOINT: 'Attribute/insert-or-update',
  ATTRIBUTE_BY_ID_API_ENDPOINT: 'Attribute/get-attribute-detail-by-id',
  ATTRIBUTE_ARCHIVE_API_ENDPOINT: 'Attribute/delete-or-archive-attribute',
  ATTRIBUTE_RESTORE_API_ENDPOINT: 'Attribute/restore-attribute',
  ATTRIBUTE_HISTORY_API_ENDPOINT:
    'Attribute/get-attribute-detail-history-by-id',

  REGION_API_ENDPOINT: 'Region/region-master',
  COUNTRY_API_ENDPOINT: 'Country/country-master',
  REFERENCE_POST_API_ENDPOINT: 'Reference/insert-or-update',
  REFERENCE_DETAIL_POST_API_ENDPOINT: 'Reference/get-reference-list',
  REFERENCE_BY_ID_API_ENDPOINT: 'Reference/get-reference-by-id',
  APPROVER_LIST: 'Approver/get-approver-list',
  APPROVER_POST_ENDPOINT: 'Approver/insert-or-update-approver',
  APPROVER_DELETE_ENDPOINT: 'Approver/delete-approver',
  STATUS_MASTER: 'Status/status-master',

  GET_USERPRIVILEGES_URL: 'RolesAndPrivileges/get-user-roles-and-privileges',
  GET_AG_GRID_KEY: 'Metadata/get-aggrid-key',
  GET_REF_HISTORY_DETAILS: 'Reference/get-reference-history-by-id',
  ARCHIVE_REF_ENDPOINT: 'Reference/delete-or-archive-reference',
  RESTORE_REF_ENDPOINT: 'Reference/restore-reference',
  GET_SUPER_ADMIN_USERS: 'Metadata/get-super-admin-users',

  ROLES_PRIVILEGES_FETCH_URL:
    'RolesAndPrivileges/get-app-role-privileges-details',
  ROLES_PRIVILEGES_UPDATE_URL:
    'RolesAndPrivileges/update-app-role-privileges-details',
  APPROVE_REJECT_REF_URL: 'Reference/approve-or-reject-reference',
};

export const CONSTANTS_DETAILS = Object.freeze(CONSTANTS_DETAILS_CONFIG);
